<template>
  <div class="auth-layout-wrap">
    <div class="auth-content">
      <div class="card o-hidden">
        <div class="row">
          <div class="col-md-6">
            <div class="p-4">
              <div class="auth-logo text-center mb-4">
                <img src="logo.png" alt="" style="width:200px; height: auto;">
              </div>
              <h1 class="mb-3 text-18">{{$t('Kayit.Kayit')}}</h1>
              <el-form v-loading="loading" :model="KayitForm" status-icon ref="KayitForm">
                <div class="form-group">

                  <el-form-item
                    prop="SUnvan"
                    :label="$t('Kayit.Unvan.Unvan')"
                    autocomplete="off"
                    :rules="[
                      { required: true, message: $t('Kayit.Unvan.required') },
                    ]">
                    <el-input v-model="KayitForm.SUnvan"></el-input>
                  </el-form-item>

                </div>
                <div class="form-group">

                  <el-form-item
                    prop="Kisim"
                    :label="$t('Kayit.Adi.Adi')"
                    autocomplete="off"
                    :rules="[
                      { required: true, message: $t('Kayit.Adi.required') },
                    ]">
                    <el-input v-model="KayitForm.Kisim"></el-input>
                  </el-form-item>

                </div>

                <div class="form-group">

                  <el-form-item
                    prop="Kemail"
                    :label="$t('Kayit.Email.Email')"
                    autocomplete="off"
                    :rules="[
                      { required: true, message: $t('Kayit.Email.requred') },
                      { type: 'email', message: $t('Kayit.Email.hata') }
                    ]">
                    <el-input v-model="KayitForm.Kemail"></el-input>
                  </el-form-item>

                </div>
                <div class="form-group">

                  <el-form-item
                    prop="Ktelefon"
                    :label="$t('Kayit.Telefon.Telefon')"
                    autocomplete="off"
                    :rules="[
                      { required: true, message: $t('Kayit.Telefon.required') },
                    ]">
                    <el-input v-model="KayitForm.Ktelefon"></el-input>
                  </el-form-item>

                </div>

                <button class="btn btn-rounded btn-primary btn-block mt-2" type="button" @click="onSubmit('KayitForm')">
                  {{$t('Kayit.Kayitbutton')}}
                </button>

              </el-form>

              <div class="mt-3 text-center">

                <router-link to="/giris" class="text-muted">
                  <u>{{$t('Kayit.giris')}}</u>
                </router-link>

              </div>
            </div>
          </div>
          <div class="col-md-6 text-center yan"></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                KayitForm: {
                    SUnvan: "Admin",
                    Kisim: "Osman Mestav",
                    Kemail: "mestav@mestav.com",
                    Ktelefon: "5388847849",
                }
            };
        },
        methods: {
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading=true;

                        this.$store.dispatch("dataver", {
                            method: 'post',
                            url: 'kayit/auth',
                            data: this.KayitForm
                        }).then(response => {
                            console.log(response)
                            if(response.Status=='OK'){
                                this.$message.error(response.Status);
                                this.loading=false;
                            }

                            if(response.Status=='NO'){
                                this.$message.error(response.Hata.Kemail);
                                this.loading=false;
                            }

                        })




                    }
                });


            }
        }
    }
</script>
<style>
  .auth-layout-wrap {
    background-image: url('../../assets/images/photo-wide-4.jpg')
  }

  .yan {
    background-size: cover;
    background-image: url('../../assets/images/photo-long-3.jpg')
  }
</style>



// WEBPACK FOOTER //
// src/Module/giris/kayit.vue